<!-- Dropdown -->
@if (
  subscriptionId() > 0 &&
  subscription()?.status.toLowerCase() !== 'void' &&
  subscription()?.status.toLowerCase() !== 'cancelled'
) {
  <div class="relative">
    <p-button
      icon="fa fa-angle-down"
      [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
      iconPos="right"
      styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 p-2 hidden md:inline-flex"
      (click)="subscriptionAction1.toggle($event)"
    />
    <p-button
      icon="fa fa-cog"
      styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 md:hidden"
      (click)="subscriptionAction1.toggle($event)"
    />
    <p-popover
      #subscriptionAction1
      styleClass="overflow-hidden right-0 text-sm w-14rem"
    >
      <ng-template #content>
        @if (subscriptionId() > 0) {
          <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
            <li
              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
              (click)="showVoidSubscription(subscription())"
            >
              <i class="fa fa-ban mr-2"></i>
              @if (
                subscription() && subscription().upgrade_from_clt_subs_id > 0
              ) {
                <span>{{ 'ADMIN.COMMON.VOID_UPGRADE' | translate }}</span>
              }
              @if (
                subscription() && subscription().upgrade_from_clt_subs_id === 0
              ) {
                <span>{{ 'ADMIN.COMMON.VOID' | translate }}</span>
              }
            </li>
            @if (showActiveMembershipBtn(subscription().status)) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="ShowActivateMembership(subscription())"
              >
                <i class="fa fa-rotate mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_ACTIVATE_MEMB' | translate }}</span>
              </li>
              @if (
                showFreeDiscountApply.value &&
                showFreeDiscount() &&
                isRecurring &&
                CanAddFreeDiscount(subscription().status)
              ) {
                <li
                  (click)="showFreeDiscountSection(subscription())"
                  class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                >
                  <i class="fa fa-percent mr-2"></i>
                  <span>{{ 'FREEDISCOUNT.BTN_ADD_DISCOUNT' | translate }}</span>
                </li>
              }
            }
            @if (showAddonBilling.value && isRecurring) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="ShowMidCycleAddon()"
              >
                <i class="fa fa-plug mr-2"></i>
                <span>{{ 'BILLING_ADDONS.MID_CYCLE_ADDON' | translate }}</span>
              </li>
            }
            @if (isNotRenewingStatus(subscription().status)) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="ReActivateMembership(subscription())"
              >
                <i class="fa-solid fa-power-off mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_RE_ACTIVATE' | translate }}</span>
              </li>
            }
            <li
              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
              [class.pointer-events-none]="isPresaleTenant"
              [class.opacity-40]="isPresaleTenant"
              (click)="goToUpgrade()"
            >
              <i class="fa fa-arrow-alt-circle-up mr-2"></i>
              <span>{{ 'SUBSCRIPTIONS.BTN_UPGRADE' | translate }}</span>
            </li>
            @if (showSubscriptionAmendment.value && canAmendSubscription(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="goToAmendment()"
                aria-label="amend-subscription-action"
              >
                <i class="fa fa-arrows-alt-v mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_AMEND' | translate }}</span>
              </li>
            }
            @if (
              isMinimumDateTimeValue(subscription().scheduled_cancellation_date)
            ) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="GoToCancel(subscription())"
              >
                <i class="fa-solid fa-power-off mr-2"></i>
                <span>{{
                  'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate
                }}</span>
              </li>
            }
            @if (
              (subscription().is_transferable || subscription().transferable) &&
              showTransfer.value
            ) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                [class.pointer-events-none]="isPresaleTenant"
                [class.opacity-40]="isPresaleTenant"
                (click)="goToTransfer()"
              >
                <i class="fa fa-exchange-alt mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_TRANSFER' | translate }}</span>
              </li>
            }
            @if (!IsSubscrptionVoidOrCancelled(subscription().status)) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                [class.pointer-events-none]="isPresaleTenant"
                [class.opacity-40]="isPresaleTenant"
                (click)="goToFreeze()"
              >
                <i class="fa fa-pause mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_FREEZE' | translate }}</span>
              </li>
            }
            @if (canShowStopBilling(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openStopBillingModal()"
                aria-label="stop-billing-action"
              >
                <i class="fa fa-ban mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_STOP_BILLING' | translate }}</span>
              </li>
            }
            @if (canShowResumeBilling(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openResumeBillingModal()"
                aria-label="resume-billing-action"
              >
                <i class="fa fa-play mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_RESUME_BILLING' | translate }}</span>
              </li>
            }
            @if (canForceSuspend(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openForceSuspendModal()"
                aria-label="force-suspend-action"
              >
                <i class="fa fa-pause-circle mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_FORCE_SUSPEND' | translate }}</span>
              </li>
            }
            @if (canForceActivate(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openForceActivateModal()"
                aria-label="force-activate-action"
              >
                <i class="fa fa-play-circle mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_FORCE_ACTIVATE' | translate }}</span>
              </li>
            }
            @if (canClearOverride(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openClearOverrideModal()"
                aria-label="clear-override-action"
              >
                <i class="fa fa-undo mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_CLEAR_OVERRIDE' | translate }}</span>
              </li>
            }
            @if (canPatchSubscription(subscription())) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="openPatchSubscriptionModal()"
                aria-label="patch-subscription-action"
              >
                <i class="fa fa-pen-to-square mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.PATCH.BTN_PATCH' | translate }}</span>
              </li>
            }
            @if (signupId() > 0) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="VoidSignUp()"
              >
                <i class="fa fa-ban mr-2"></i>
                <span>{{ 'common.BUTTONS.BTN_VOID_SIGNUP' | translate }}</span>
              </li>
            }
            @if (
              CanSendCollectionDuesLink(subscription().status) && isRecurring
            ) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="SendLinkCollectDuesClick()"
              >
                <i class="fa fa-link mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.SEND_MANAGE_LINK' | translate }}</span>
              </li>
            }
            @if (
              subscription().family_owner_subs_id > 0 &&
              subscription().family_owner_subs_id === subscriptionId()
            ) {
              <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                (click)="showAddMemberToSubscription()"
              >
                <i class="fa fa-user-plus mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.ADD_MEMBER' | translate }}</span>
              </li>
            }
          </ul>
        }
      </ng-template>
    </p-popover>
  </div>
}

<!-- Dropdown -->

@if (subscriptionId() === 0) {
  <div class="relative">
    <p-button
      icon="fa fa-angle-down"
      [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
      iconPos="right"
      styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 p-2 hidden md:inline-flex"
      (click)="subscriptionAction2.toggle($event)"
    />
    <p-button
      icon="fa fa-cog"
      styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 md:hidden"
      (click)="subscriptionAction2.toggle($event)"
    />
    <p-popover
      #subscriptionAction2
      styleClass="overflow-hidden right-0 text-sm w-14rem"
    >
      <ng-template #content>
        @if (subscriptionId() === 0) {
          <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
            <li
              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
              (click)="VoidSignUp()"
            >
              <i class="fa fa-ban mr-2"></i>
              <span>{{ 'common.BUTTONS.BTN_VOID_SIGNUP' | translate }}</span>
            </li>
          </ul>
        }
      </ng-template>
    </p-popover>
  </div>
}

<!-- Dropdown -->

<!-- Void subscription Modal -->
<p-dialog
  [visible]="showVoidSubscriptionModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form [formGroup]="voidSubscriptionForm">
      <div class="relative text-center p-4">
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidSubscriptionModal = false"
        ></div>

        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
        />

        <h4 class="text-base md:text-lg my-3 font-bold">
          {{ 'SUBSCRIPTIONS.VOID_SUBSCRIPTION' | translate }} <br />
          {{
            subscription().name_primary_language ||
              subscription().name_secondary_language | titlecase
          }}
          ?
        </h4>
        @if (!upgradedSubscription) {
          <ul class="text-left text-sm mb-0">
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO1' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO2' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO3' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO4' | translate }}
            </li>
          </ul>
        }
        @if (upgradedSubscription) {
          <ul class="text-left text-sm mb-0">
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO1' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO2' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO3' | translate }}
            </li>
            <li class="my-1">
              {{ 'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO4' | translate }}
            </li>
          </ul>
        }
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'INVOICE.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (VoidReasonFormControl.touched && VoidReasonFormControl.invalid) {
          <app-error-msg
            [errors]="VoidReasonFormControl.errors"
            [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="showVoidSubscriptionModal = false"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SUBSCRIPTIONS.BTN_VOID' | translate"
          class="p-button-danger text-sm"
          [loading]="btnLoading$ | async"
          (click)="voidSubscription(voidSubscriptionForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>

    @if (showErrorPopup | async; as show_Popup) {
      <app-errors
        [visible]="show_Popup"
        (onHide)="closeDialog()"
        (onHide)="closeDialog()"
        [errorData]="errorMessages"
        [error]="error"
        (hideErrorPopup)="HideErrorPopup($event)"
      />
    }
  </ng-template>
</p-dialog>
<!-- Void subscription Modal -->

<!-- Activate subscription Modal -->
<p-dialog
  [visible]="ActivateMembershipPopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <form [formGroup]="ActivateMebershipForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'common.HEADERS.CONFIRM_ACTIVEATE_MEMB' | translate }}
        </h4>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="ActivateMembershipPopup = false"
        ></div>
        <!-- <span class="text-sm text-blue-600">{{ 'SUBSCRIPTIONS.ACTIVATE_INFO'  | translate }} </span> -->
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            icon="fa fa-exclamation-triangle"
            aria-label="activate-info-message"
            data-testid="activate-info-message"
          >
            <!-- {{ 'SUBSCRIPTIONS.ACTIVATE_INFO' | translate }} -->
            {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_INFO' | translate }}
          </p-message>
        </div>
        <textarea
          pInputTextarea
          formControlName="change_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (
          ChangeReasonActiveFormControl.touched &&
          ChangeReasonActiveFormControl.invalid
        ) {
          <app-error-msg
            [errors]="ChangeReasonActiveFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.REASON' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <div class="w-4"></div>
        <div class="w-8 text-right">
          <p-confirmpopup key="activatemembership" />
          <button
            pButton
            pRipple
            type="button"
            [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
            class="p-button-primary text-sm"
            (click)="ActivateConfirm($event)"
          ></button>
        </div>
      </div>
      <!-- Modal Footer -->
    </form>

    @if (showErrorPopup | async; as show_Popup) {
      <app-errors
        [visible]="show_Popup"
        (onHide)="closeDialog()"
        (onHide)="closeDialog()"
        [errorData]="errorMessages"
        [error]="error"
        (hideErrorPopup)="HideErrorPopup($event)"
      />
    }
  </ng-template>
</p-dialog>
<!-- Activate subscription Modal -->

<p-dialog
  [visible]="voidSignUpPopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <form [formGroup]="VoidSubscriptionSignupForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'common.HEADERS.CONFIRM_VOID_SIGNUP' | translate }}
        </h4>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="voidSignUpPopup = false; voidSignUpBtnLoading = false"
        ></div>
        <!-- <span class="text-sm text-blue-600">{{ 'SUBSCRIPTIONS.ACTIVATE_INFO'  | translate }} </span> -->
      </div>
      <!-- Header -->
      <!-- Content -->
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            icon="fa fa-exclamation-triangle"
            aria-label="signup-void-info-message"
            data-testid="signup-void-info-message"
          >
            {{ 'SUBSCRIPTIONS.SIGNUP_VOID_INFO' | translate }}
          </p-message>
        </div>

        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reasons"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (
          VoidSignupReasonFormControl.touched &&
          VoidSignupReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="VoidSignupReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.REASON' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <div class="w-4"></div>
        <div class="w-8 text-right">
          <p-confirmpopup key="activatemembership" />
          <button
            pButton
            pRipple
            type="button"
            [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
            class="p-button-primary text-sm"
            (click)="SubmitVoidSignup($event)"
          ></button>
        </div>
      </div>
      <!-- Modal Footer -->
    </form>
    @if (showErrorPopup | async; as show_Popup) {
      <app-errors
        [visible]="show_Popup"
        (onHide)="closeDialog()"
        [errorData]="errorMessages"
        [error]="error"
        (hideErrorPopup)="HideErrorPopup($event)"
      />
    }
  </ng-template>
</p-dialog>

@if (addDiscountedPeriod) {
  <subscription-free-discount
    [visible]="addDiscountedPeriod"
    (onHide)="closeDialog()"
    [clientDetails]="clientDetails"
    [clientId]="clientId()"
    [tenantId]="tenantId()"
    [subscriptionId]="subscriptionId()"
    [timelines]="paymentTimelineData()"
    (closePopup)="closeFreeDiscountPopup($event)"
  />
}

@if (showAddonSidebar) {
  <billing-add-on
    [visible]="showAddonSidebar"
    (onHide)="closeDialog()"
    [tenantId]="tenantId()"
    [planId]="localPlanId"
    [mode]="'midcycleaddon'"
    [selectedAddons]="selectedAddons"
    (closeAddonSidebar)="closeAddonSidebar($event)"
  />
}

@if (showCancelSubscription) {
  <subscription-cancel
    [visible]="showCancelSubscription"
    (onHide)="closeDialog()"
    [clientId]="clientId()"
    [tenantId]="tenantId()"
    [subscription]="clientSubscriptionData | async"
    (closeEvent)="closeSubscriptionCancelEvent($event)"
  />
}

<!-- Send Link - Collect Dues  -->
<p-dialog
  [visible]="sendLinkCollectDues"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '600px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form>
      <!-- Modal Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          {{
            'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHEADER' | translate
          }}
        </h2>
        <i
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="sendLinkCollectDues = false"
        ></i>
      </div>
      <!-- Modal Header -->

      <div class="py-4 px-3">
        <p class="text-sm mb-5">
          {{ 'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHELP' | translate }}
        </p>

        <h4 class="text-sm text-600 mb-2 font-normal">
          {{ 'SUBSCRIPTIONS.COLLECTDUES_SENDON' | translate }}
        </h4>

        <div class="p-buttonset white-space-nowrap">
          <button
            [class.p-button-primary]="emailSelected"
            [class.p-button-secondary]="!emailSelected"
            (click)="emailSelected = !emailSelected"
            class="border-right-1 text-sm border-white"
            pButton
            pRipple
            label="{{ 'SUBSCRIPTIONS.COLLECTDUES_EMAIL' | translate }}"
            icon="fa fa-envelope font-light"
          ></button>
          <button
            [class.p-button-primary]="smsSelected"
            [class.p-button-secondary]="!smsSelected"
            (click)="smsSelected = !smsSelected"
            class="border-right-1 text-sm border-white"
            pButton
            pRipple
            label="{{ 'SUBSCRIPTIONS.COLLECTDUES_SMS' | translate }}"
            icon="fa fa-comments font-light"
          ></button>
          <button
            [class.p-button-primary]="whatsappSelected"
            [class.p-button-secondary]="!whatsappSelected"
            (click)="whatsappSelected = !whatsappSelected"
            class="border-right-1 text-sm border-white"
            pButton
            pRipple
            label="{{ 'SUBSCRIPTIONS.COLLECTDUES_WHATSAPP' | translate }}"
            icon="fab fa-whatsapp"
          ></button>
          <button
            [class.p-button-primary]="mobileNotificationSelected"
            [class.p-button-secondary]="!mobileNotificationSelected"
            (click)="mobileNotificationSelected = !mobileNotificationSelected"
            class="border-right-1 text-sm border-white"
            pButton
            pRipple
            label="{{
              'SUBSCRIPTIONS.COLLECTDUES_MOBILE_NOTIFICATION' | translate
            }}"
            icon="fa fa-bell"
          ></button>
        </div>
      </div>

      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="p-3 border-top-1 border-300 flex align-items-center justify-content-between"
      >
        <p-button
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="sendLinkCollectDues = false"
        />

        <p-button
          pRipple
          type="button"
          [label]="'SUBSCRIPTIONS.BTN_SEND' | translate"
          [loading]="btnLoading"
          (click)="funSendCollectDuesLink($event)"
          styleClass="text-sm"
        />
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Send Link - Collect Dues -->

<!-- Stop Billing Modal -->
<p-dialog
  [visible]="showStopBillingModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="stopBillingForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'SUBSCRIPTIONS.STOP_BILLING_TITLE' | translate }}
        </h4>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeStopBillingModal()"
          aria-label="close-stop-billing-dialog"
        ></div>
      </div>
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="warn"
            icon="fa fa-exclamation-triangle"
            aria-label="stop-billing-info-message"
          >
            {{ 'SUBSCRIPTIONS.STOP_BILLING_INFO' | translate }}
          </p-message>
        </div>
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.STOP_BILLING_REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="stop_billing_reason"
          class="text-sm w-full h-5rem"
          aria-label="stop-billing-reason-input"
        ></textarea>
        @if (
          StopBillingReasonFormControl.touched &&
          StopBillingReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="StopBillingReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.STOP_BILLING_REASON' | translate"
          />
        }
      </div>
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="closeStopBillingModal()"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
          class="p-button-danger text-sm"
          [loading]="stopBillingBtnLoading"
          (click)="submitStopBilling()"
          aria-label="confirm-stop-billing"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- Stop Billing Modal -->

<!-- Resume Billing Modal -->
<p-dialog
  [visible]="showResumeBillingModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="resumeBillingForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'SUBSCRIPTIONS.RESUME_BILLING_TITLE' | translate }}
        </h4>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeResumeBillingModal()"
          aria-label="close-resume-billing-dialog"
        ></div>
      </div>
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            icon="fa fa-info-circle"
            aria-label="resume-billing-info-message"
          >
            {{ 'SUBSCRIPTIONS.RESUME_BILLING_INFO' | translate }}
          </p-message>
        </div>
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.RESUME_BILLING_REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="resume_billing_reason"
          class="text-sm w-full h-5rem"
          aria-label="resume-billing-reason-input"
        ></textarea>
        @if (
          ResumeBillingReasonFormControl.touched &&
          ResumeBillingReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="ResumeBillingReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.RESUME_BILLING_REASON' | translate"
          />
        }
      </div>
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="closeResumeBillingModal()"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
          class="p-button-primary text-sm"
          [loading]="resumeBillingBtnLoading"
          (click)="submitResumeBilling()"
          aria-label="confirm-resume-billing"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- Resume Billing Modal -->

<!-- Force Status Modal -->
<p-dialog
  [visible]="showForceStatusModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '560px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="forceStatusForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ forceStatusModalTitleKey | translate }}
        </h4>
        <button
          type="button"
          class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
          (click)="closeForceStatusModal()"
          aria-label="close-force-status-dialog"
        ></button>
      </div>
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="warn"
            icon="fa fa-exclamation-triangle"
            aria-label="force-status-info-message"
          >
            {{ forceStatusModalInfoKey | translate }}
          </p-message>
        </div>
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.FORCE_STATUS_REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="status_change_reason"
          class="text-sm w-full h-5rem"
          aria-label="force-status-reason-input"
        ></textarea>
        @if (
          ForceStatusReasonFormControl.touched &&
          ForceStatusReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="ForceStatusReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.FORCE_STATUS_REASON' | translate"
          />
        }
      </div>
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="closeForceStatusModal()"
          aria-label="cancel-force-status"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
          class="p-button-danger text-sm"
          [loading]="forceStatusBtnLoading"
          (click)="submitForceStatus()"
          aria-label="confirm-force-status"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- Force Status Modal -->

<!-- Clear Override Modal -->
<p-dialog
  [visible]="showClearOverrideModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="clearOverrideForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_TITLE' | translate }}
        </h4>
        <button
          type="button"
          class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
          (click)="closeClearOverrideModal()"
          aria-label="close-clear-override-dialog"
        ></button>
      </div>
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            icon="fa fa-info-circle"
            aria-label="clear-override-info-message"
          >
            {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_INFO' | translate }}
          </p-message>
        </div>
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.CLEAR_OVERRIDE_REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="override_change_reason"
          class="text-sm w-full h-5rem"
          aria-label="clear-override-reason-input"
        ></textarea>
        @if (
          ClearOverrideReasonFormControl.touched &&
          ClearOverrideReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="ClearOverrideReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.CLEAR_OVERRIDE_REASON' | translate"
          />
        }
      </div>
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="closeClearOverrideModal()"
          aria-label="cancel-clear-override"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SUBSCRIPTIONS.BTN_CLEAR_OVERRIDE' | translate"
          class="p-button-primary text-sm"
          [loading]="clearOverrideBtnLoading"
          (click)="submitClearOverride()"
          aria-label="confirm-clear-override"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- Clear Override Modal -->

<!-- Add Member to Subscription Modal -->
<p-dialog
  [visible]="showAddMemberModal"
  [modal]="true"
  [resizable]="false"
  appendTo="body"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '600px', height: 'fit-content' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h4 class="text-base font-normal mb-0">
        {{ 'SUBSCRIPTIONS.ADD_MEMBER_TO_SUBSCRIPTION' | translate }}
      </h4>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="closeAddMemberModal()"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <form [formGroup]="addMemberForm">
      <div class="surface-100 p-4">
        <div class="mb-3">
          <p-message
            severity="info"
            icon="fa fa-info-circle"
            aria-label="add-member-info-message"
            data-testid="add-member-info-message"
          >
            {{ 'SUBSCRIPTIONS.ADD_MEMBER_INFO' | translate }}
          </p-message>
        </div>

        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.SELECT_FAMILY_MEMBER' | translate
        }}</label>

        <mini-search
          [clientId]="selectedFamilyMember ? selectedFamilyMember.clt_id : 0"
          [readonly]="false"
          [showSelected]="true"
          [showCreateClient]="false"
          (clients)="onFamilyMemberSelected($event)"
          (removedClient)="onFamilyMemberRemoved($event)"
          aria-label="family-member-search"
          data-testid="family-member-search"
        />

        <!-- <div *ngIf="selectedFamilyMember" class="mt-3 p-3 surface-50 border-round">
                    <div class="flex align-items-center">
                        <div class="mr-3">
                            <ng-container *ngIf="selectedFamilyMember.clt_image">
                                <p-avatar image="{{selectedFamilyMember.clt_image}}" shape="circle" aria-label="selected-member-avatar" data-testid="selected-member-avatar"></p-avatar>
                            </ng-container>
                            <ng-container *ngIf="!selectedFamilyMember.clt_image">
                                <p-avatar [label]="selectedFamilyMember.clt_full_name | titlecase" shape="circle" aria-label="selected-member-initials" data-testid="selected-member-initials"></p-avatar>
                            </ng-container>
                        </div>
                        <div>
                            <div class="font-semibold text-900">{{selectedFamilyMember.clt_full_name}}</div>
                            <div class="text-600 text-sm">{{'Shared.SEARCH.MINI-SEARCH.CLIENT_ID' | translate}} {{selectedFamilyMember.clt_id}}</div>
                        </div>
                    </div>
                </div> -->

        @if (MemberIdFormControl.touched && MemberIdFormControl.invalid) {
          <app-error-msg
            [errors]="MemberIdFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.FAMILY_MEMBER_REQUIRED' | translate"
          />
        }
      </div>
    </form>
    <!-- Content -->

    <!-- Modal Footer -->
    <div
      class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
    >
      <p-button
        pRipple
        [text]="true"
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="text-sm"
        (click)="closeAddMemberModal()"
      />
      <p-button
        pRipple
        [label]="'SUBSCRIPTIONS.BTN_ADD_MEMBER' | translate"
        [disabled]="!addMemberForm.valid"
        class="p-button-primary p-button-text text-sm"
        [loading]="addMemberLoading"
        (click)="addMemberToSubscription()"
      />
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Add Member to Subscription Modal -->

@if (showPatchSubscriptionModal) {
  <app-subscription-patch
    [visible]="showPatchSubscriptionModal"
    [subscriptionId]="subscriptionId()"
    [clientId]="clientId()"
    (closeEvent)="closePatchSubscriptionModal($event)"
  />
}
